import { useRef } from "react";
import { DataTable, DataTableRowEditCompleteEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { DistrictDTOModel } from "../../models/cust-address/cust-address-model";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

interface DataTableProps {
  data: DistrictDTOModel[];
  NoofRecords: number;
  pageNumber: number;
  pageSize: number;
  searchTerm: any;
  onPageChange: (event: any) => void;
  onUpdateDistrict?: (id: number, newName: string) => Promise<boolean>;
  onDeleteDistrict?: (district: DistrictDTOModel) => void;
}

const DistrictDataTable: React.FC<DataTableProps> = ({
  data,
  NoofRecords,
  pageNumber,
  pageSize,
  searchTerm,
  onPageChange,
  onUpdateDistrict,
  onDeleteDistrict
}) => {
  const toast = useRef<Toast>(null);

  const DistrictEditor = (options: ColumnEditorOptions) => {
    return (
      <InputText
        type="text"
        value={options.value}
        style={{ width: "95%", border: "1px solid #090" }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          options.editorCallback!(e.target.value)
        }
      />
    );
  };

  const onRowEditComplete = async (e: DataTableRowEditCompleteEvent) => {
    const { newData } = e;
    try {
      if (onUpdateDistrict) {
        await onUpdateDistrict(newData.districtId, newData.districtName);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deleteTemplate = (rowData: DistrictDTOModel) => {
    return (
      <Button
        icon="pi pi-trash"
        onClick={() => onDeleteDistrict && onDeleteDistrict(rowData)}
        style={{ border: 'none', color: 'gray', background: 'none' }}
        className="p-button-rounded"
       //tooltip="Delete District"
        tooltipOptions={{ position: 'top' }}
      />
    );
  };

  return (
    
    <div className="col-12">
      <div className="card border-noround p-2">
      <Toast ref={toast} />
      <DataTable
        value={data}
        editMode="row"
        paginator
        rows={pageSize}
        rowsPerPageOptions={[5, 10, 25, 50]}
        totalRecords={NoofRecords}
        lazy
        first={(pageNumber - 1) * pageSize}
        onPage={onPageChange}
        onRowEditComplete={onRowEditComplete}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate={`{first} to {last} of ${NoofRecords}`}
      >
        <Column field="districtName" header="District" editor={DistrictEditor} style={{ width: "18%" }} />
        <Column field="stateName" header="State" style={{ width: "20%" }} />
        <Column field="countryName" header="Country" style={{ width: "15%" }} />
        <Column rowEditor header="Edit" headerStyle={{ width: "10%" }} />
        <Column body={deleteTemplate} header="Delete" style={{ width: "5%" }} />
      </DataTable>
      </div>
    </div>
  );
};

export default DistrictDataTable;